class Round {
  static isValid(round) {
    return typeof round === 'string' && /^\d{4}Q\d+/.test(round);
  }

  constructor(round) {
    const split = round.split('Q');

    this.year = parseInt(split[0], 10);
    if (split[1].includes('_')) {
      const [quarter, extra] = split[1].split('_');
      this.quarter = parseInt(quarter, 10);
      this.extra = extra;
    } else {
      [, this.quarter] = split;
      this.extra = '';
    }
  }

  minus(quarter) {
    let quarterBefore = this.quarter - quarter;
    let yearBefore = this.year;
    if (quarterBefore <= 0) {
      quarterBefore += 4;
      yearBefore -= 1;
    }
    return `${yearBefore}Q${quarterBefore}`;
  }

  quarterEarlier() {
    return this.minus(1);
  }

  halfYearEarlier() {
    return this.minus(2);
  }

  threeQuarterEarlier() {
    return this.minus(3);
  }

  compare(round) {
    if (this.year !== round.year) return this.year - round.year;

    if (this.quarter !== round.quarter) return this.quarter - round.quarter;

    if (this.extra !== round.extra) return this.extra.localeCompare(round.extra);

    return 0;
  }

  latestQuarters() {
    return [
      this.toString(),
      this.quarterEarlier(),
      this.halfYearEarlier(),
      this.threeQuarterEarlier()
    ];
  }

  toString() {
    return `${this.year}Q${this.quarter}${this.extra ? `_${this.extra}` : ''}`;
  }

  isAfter(toCompare) {
    return this.compare(toCompare) > 0;
  }
}

// Splits rows into those with a parseable round and the distinct invalid
// round values encountered (e.g. legacy free-text rounds from imports).
export function partitionByRoundValidity(rows) {
  const valid = [];
  const invalidRounds = new Set();
  rows.forEach((item) => {
    if (Round.isValid(item?.round)) {
      valid.push(item);
    } else {
      invalidRounds.add(item?.round);
    }
  });
  return { valid, invalidRounds: [...invalidRounds] };
}

export default Round;
